import React, { useEffect } from 'react'

function ProgressDots( props ) {
    useEffect(() => {
        // console.log(props);
    }, []);

    const handleClick = (e) => {
        props.setCurrentYear(e.target.innerText);
    };

    return (
        <div className="timeline-progress-dots">
            {props.years && props.years.map((y) => (
                <button
                    key={y}
                    className={y === props.currentYear ? 'current' : ''}
                    onClick={handleClick}
                >{y}
                </button>
            ))}
        </div>
    );
}

export default ProgressDots;
